module.exports = __webpack_public_path__ + "static/icons/icon-heart-fill-55d34323344657a256a3816b02078948.svg";